exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Vehicle File Sidebar Component Styles */\n/* Toggle label font size for this component only */\n.pending-investigations .mat-slide-toggle {\n  height: auto;\n  padding-bottom: 4px; }\n  .pending-investigations .mat-slide-toggle ::ng-deep .mat-slide-toggle-content {\n    -ms-flex-positive: 0;\n        flex-grow: 0;\n    -ms-flex-negative: 1;\n        flex-shrink: 1;\n    text-wrap: wrap; }\n  .pending-investigations .mat-slide-toggle ::ng-deep .mat-slide-toggle-bar {\n    -ms-flex-negative: 0;\n        flex-shrink: 0; }\n\n/* Groups the investigation toggles under their own heading */\n.investigation-filters {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #e7e7e7; }\n  .investigation-filters .investigation-filters__title {\n    margin: 0 0 8px;\n    font-size: 13px;\n    font-weight: 600; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/Vehicle-file/components/vehicle-file-sidebar/vehicle-file-sidebar.scss
// module id = ../../../../../src/app/Vehicle-file/components/vehicle-file-sidebar/vehicle-file-sidebar.scss
// module chunks = main